(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["booking-app"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.cfbReady === '1') return;
    root.dataset.cfbReady = '1';

    var cfgEl = root.querySelector('[data-cfb-config]');
    var formCart    = root.querySelector('[data-cfb-form="cart"]');
    var formRequest = root.querySelector('[data-cfb-form="request"]');
    var form = formCart;
    if (!cfgEl || !form) return;

    var CFG;
    try {
      CFG = JSON.parse(cfgEl.textContent);
    } catch (e) {
      // Mieux vaut un message visible qu'une page muette : sans configuration,
      // le calendrier ne peut pas se dessiner et la cliente ne comprendrait pas.
      var warn = document.createElement('p');
      warn.className = 'cfb__notice cfb__notice--warn';
      warn.textContent = 'Le module de réservation n\'a pas pu démarrer. Contactez-nous par téléphone ou par e-mail pour votre rendez-vous.';
      var host = root.querySelector('.cfb__wrap') || root;
      host.insertBefore(warn, host.firstChild);
      if (window.console) console.error('[booking] configuration JSON invalide :', e);
      return;
    }

    var L = CFG.labels;
    // Les éléments interactifs sont des <span role="button"> : l'état désactivé
    // passe par aria-disabled, pas par la propriété .disabled qui n'existe pas.
    function setOff(el, off) {
      if (!el) return;
      if ('disabled' in el && el.tagName === 'BUTTON') el.disabled = off;
      el.setAttribute('aria-disabled', off ? 'true' : 'false');
      if (el.hasAttribute('tabindex')) el.setAttribute('tabindex', off ? '-1' : '0');
    }
    function isOff(el) {
      return !el || el.getAttribute('aria-disabled') === 'true' || el.disabled === true;
    }

    var $  = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* ---------------- Helpers dates ---------------- */
    // Les dates sont manipulées en UTC pour éviter tout décalage lié au fuseau
    // du navigateur. Le jour de référence vient du serveur Shopify.
    function parseISO(s) {
      var p = String(s || '').split('-');
      return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    }
    function toISO(d) {
      return d.getUTCFullYear() + '-' +
        String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
        String(d.getUTCDate()).padStart(2, '0');
    }
    function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
    // 0 = lundi … 6 = dimanche
    function isoWeekday(d) { return (d.getUTCDay() + 6) % 7; }
    function minutes(hm) { var p = String(hm || '0:0').split(':'); return (+p[0]) * 60 + (+p[1] || 0); }
    function hm(mins) { return String(Math.floor(mins / 60)).padStart(2, '0') + ':' + String(mins % 60).padStart(2, '0'); }

    function csvSet(str) {
      var out = {};
      String(str || '').split(/[\n,;]+/).forEach(function (t) {
        t = t.trim();
        if (t) out[t] = true;
      });
      return out;
    }

    var TODAY      = parseISO(CFG.today);
    var CLOSED     = csvSet(CFG.closedDates);
    var BOOKED     = csvSet(CFG.bookedSlots);   // format "2026-09-14 14:30"
    var OPEN_DAYS  = String(CFG.openDays || '1,2,3,4,5,6').split(',').map(function (n) { return parseInt(n, 10); });
    var MAX_DATE   = addDays(TODAY, Math.max(1, CFG.maxDaysAhead));

    // La valeur d'option du produit et le nom du bloc doivent se retrouver même
    // s'ils ne sont pas identiques au caractère près : « Consultation en visio »
    // dans le bloc contre « Consultation en visio 30 min » sur le produit
    // faisait silencieusement retomber la durée sur la valeur par défaut.
    var SERVICES = (CFG.services || []).filter(function (x) { return x && x.value; });

    function norm(v) {
      return String(v || '').toLowerCase()
        .normalize ? String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim()
                   : String(v || '').toLowerCase().trim();
    }

    function matchService(value) {
      var v = norm(value);
      if (!v) return null;
      var i, n;
      for (i = 0; i < SERVICES.length; i++) if (norm(SERVICES[i].value) === v) return SERVICES[i];
      for (i = 0; i < SERVICES.length; i++) {
        n = norm(SERVICES[i].value);
        if (n && (v.indexOf(n) === 0 || n.indexOf(v) === 0)) return SERVICES[i];
      }
      for (i = 0; i < SERVICES.length; i++) {
        n = norm(SERVICES[i].value);
        if (n && (v.indexOf(n) > -1 || n.indexOf(v) > -1)) return SERVICES[i];
      }
      return null;
    }

    /* ---------------- État ---------------- */
    var state = {
      options: [],           // valeur choisie par index d'option produit
      date: null,            // "YYYY-MM-DD"
      time: null,            // "HH:MM"
      cursor: new Date(Date.UTC(TODAY.getUTCFullYear(), TODAY.getUTCMonth(), 1))
    };

    // Indices des options « prestation » et « paiement »
    var idxPayment = -1, idxService = -1;
    (CFG.optionNames || []).forEach(function (name, i) {
      var n = String(name).toLowerCase();
      if (n.indexOf('paiement') > -1 || n.indexOf('payment') > -1 || n.indexOf('règlement') > -1) idxPayment = i;
      else if (idxService === -1) idxService = i;
    });
    if (idxService === -1) idxService = 0;

    // Valeurs initiales = premier bouton de chaque option
    $$('[data-cfb-option]').forEach(function (btn) {
      var i = +btn.getAttribute('data-cfb-option');
      if (state.options[i] === undefined) state.options[i] = btn.getAttribute('data-cfb-value');
    });

    /* ------------- Mode de paiement et parcours ------------- */
    // Mots-clés reconnus comme « règlement sur place », quel que soit le
    // libellé exact choisi sur le produit Shopify.
    var ONSITE = ['sur place', 'salon', 'espèce', 'espece', 'cash', 'sur site'];

    function isOnsite() {
      if (idxPayment < 0) return false;
      var v = String(state.options[idxPayment] || '').toLowerCase();
      return ONSITE.some(function (o) { return v.indexOf(o) > -1; });
    }
    // Le parcours « demande » n'existe que si la marchande l'a choisi.
    function useRequest() {
      return CFG.onsiteMode === 'request' && isOnsite() && !!formRequest;
    }
    function activeForm() { return useRequest() ? formRequest : formCart; }

    function applyFlow() {
      var req = useRequest();
      if (formCart) formCart.hidden = req;
      if (formRequest) formRequest.hidden = !req;
      $$('[data-cfb-only="request"]').forEach(function (el) { el.hidden = !req; });
      var note = $('[data-cfb-onsite]');
      if (note) note.hidden = !isOnsite();
      var bar = $('[data-cfb-bar-submit]');
      if (bar) bar.textContent = req ? (CFG.submitOnsite || '') : (CFG.submitOnline || '');
    }

    /* ---------------- Variantes ---------------- */
    function currentService() {
      return matchService(state.options[idxService]);
    }
    function duration() {
      var s = currentService();
      return (s && s.duration) || CFG.defaultDuration || 60;
    }
    function findVariant() {
      var want = state.options;
      for (var i = 0; i < CFG.variants.length; i++) {
        var v = CFG.variants[i], ok = true;
        for (var j = 0; j < want.length; j++) {
          if (want[j] !== undefined && v.options[j] !== want[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    // Signale visuellement les combinaisons épuisées SANS désactiver le bouton.
    // Désactiver créerait une impasse : avec « Sur place » sélectionné, une
    // prestation qui n'existe qu'en ligne deviendrait définitivement
    // inatteignable. On laisse cliquer, puis on réconcilie.
    function markChoices() {
      $$('[data-cfb-option]').forEach(function (btn) {
        var i = +btn.getAttribute('data-cfb-option');
        var probe = state.options.slice();
        probe[i] = btn.getAttribute('data-cfb-value');
        var exists = CFG.variants.some(function (v) {
          return v.available && probe.every(function (val, k) { return val === undefined || v.options[k] === val; });
        });
        btn.setAttribute('data-cfb-unavailable', exists ? 'false' : 'true');
      });
    }

    function syncChoiceButtons() {
      $$('[data-cfb-option]').forEach(function (b) {
        var i = +b.getAttribute('data-cfb-option');
        b.setAttribute('aria-pressed', b.getAttribute('data-cfb-value') === state.options[i] ? 'true' : 'false');
      });
    }

    // Après un clic, si la combinaison choisie n'existe pas ou n'est pas
    // disponible, on adopte la variante disponible la plus proche en gardant
    // la valeur que la cliente vient de choisir.
    function reconcile(changedIdx) {
      var v = findVariant();
      if (v && v.available) return;

      var target = null;
      for (var i = 0; i < CFG.variants.length; i++) {
        var c = CFG.variants[i];
        if (!c.available) continue;
        if (changedIdx === undefined || c.options[changedIdx] === state.options[changedIdx]) { target = c; break; }
      }
      if (!target) {
        for (var j = 0; j < CFG.variants.length; j++) {
          if (CFG.variants[j].available) { target = CFG.variants[j]; break; }
        }
      }
      if (!target) return;

      for (var k = 0; k < state.options.length; k++) state.options[k] = target.options[k];
      syncChoiceButtons();
    }

    /* ---------------- Créneaux ---------------- */
    function dayIsOpen(d) {
      if (d < TODAY) return false;
      if (d > MAX_DATE) return false;
      if (CLOSED[toISO(d)]) return false;
      return OPEN_DAYS.indexOf(isoWeekday(d) + 1) > -1;
    }

    function buildSlots(iso, mayCross) {
      var out = [];
      var dur = duration();
      var step = dur + (CFG.buffer || 0);
      if (step <= 0) step = 60;

      var open = minutes(CFG.openTime), close = minutes(CFG.closeTime);
      var bStart = CFG.breakStart ? minutes(CFG.breakStart) : null;
      var bEnd   = CFG.breakEnd ? minutes(CFG.breakEnd) : null;

      // Délai de prévenance : rien avant now + leadHours
      var earliest = -Infinity;
      var lead = (CFG.leadHours || 0) * 60;
      var diffDays = Math.round((parseISO(iso) - TODAY) / 86400000);
      if (diffDays * 1440 < lead) {
        earliest = minutes(CFG.nowTime) + lead - diffDays * 1440;
      }

      for (var t = open; t + dur <= close; t += step) {
        if (!mayCross && bStart !== null && bEnd !== null && t < bEnd && (t + dur) > bStart) continue;
        var label = hm(t);
        out.push({
          time: label,
          taken: !!BOOKED[iso + ' ' + label],
          tooSoon: t < earliest
        });
      }
      return out;
    }

    function slotsFor(iso) {
      var svcNow = currentService();
      var allowed = !!(svcNow && svcNow.spansBreak);
      var list = buildSlots(iso, allowed);

      // Une prestation de 7h ne tient ni avant ni après une pause déjeuner.
      // Sans ce repli, elle n'afficherait aucune date et rien n'expliquerait
      // pourquoi. On autorise donc le chevauchement dès qu'il est la seule
      // façon de proposer un créneau — la case du bloc reste un choix
      // explicite pour les prestations plus courtes.
      if (!list.length && !allowed) list = buildSlots(iso, true);
      return list;
    }

    function dayHasSlot(d) {
      if (!dayIsOpen(d)) return false;
      var s = slotsFor(toISO(d));
      for (var i = 0; i < s.length; i++) if (!s[i].taken && !s[i].tooSoon) return true;
      return false;
    }

    /* ---------------- Rendu ---------------- */
    function renderCalendar() {
      var wrap = $('[data-cfb-days]');
      var monthEl = $('[data-cfb-month]');
      if (!wrap || !monthEl) return;

      var y = state.cursor.getUTCFullYear(), m = state.cursor.getUTCMonth();
      monthEl.textContent = L.months[m] + ' ' + y;

      var first = new Date(Date.UTC(y, m, 1));
      var pad = isoWeekday(first);
      var daysInMonth = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();

      wrap.textContent = '';
      var frag = document.createDocumentFragment();

      for (var p = 0; p < pad; p++) {
        var sp = document.createElement('span');
        sp.className = 'cfb__day cfb__day--pad';
        frag.appendChild(sp);
      }

      for (var day = 1; day <= daysInMonth; day++) {
        var d = new Date(Date.UTC(y, m, day));
        var iso = toISO(d);
        var free = dayHasSlot(d);

        var b = document.createElement('span');
        b.setAttribute('role', 'button');
        b.setAttribute('tabindex', free ? '0' : '-1');
        b.className = 'cfb__day ' + (free ? 'cfb__day--free' : 'cfb__day--off');
        if (iso === CFG.today) b.className += ' cfb__day--today';
        b.textContent = String(day);
        b.setAttribute('data-cfb-date', iso);
        b.setAttribute('aria-pressed', state.date === iso ? 'true' : 'false');
        b.setAttribute('aria-label', day + ' ' + L.months[m] + ' ' + y + (free ? '' : ' — ' + L.unavailable));
        b.setAttribute('aria-disabled', free ? 'false' : 'true');
        frag.appendChild(b);
      }

      wrap.appendChild(frag);

      explainIfEmpty();

      setOff($('[data-cfb-prev]'),
             (y < TODAY.getUTCFullYear()) || (y === TODAY.getUTCFullYear() && m <= TODAY.getUTCMonth()));
      var lastAllowed = new Date(Date.UTC(MAX_DATE.getUTCFullYear(), MAX_DATE.getUTCMonth(), 1));
      setOff($('[data-cfb-next]'), new Date(Date.UTC(y, m, 1)) >= lastAllowed);
    }

    // Un calendrier entièrement grisé ne dit rien à la cliente ni à la
    // marchande. On nomme la cause au lieu de laisser deviner.
    function explainIfEmpty() {
      var host = $('[data-cfb-cal-note]');
      if (!host) return;
      var any = false;
      for (var i = 0; i <= (CFG.maxDaysAhead || 60); i++) {
        if (dayHasSlot(addDays(TODAY, i))) { any = true; break; }
      }
      if (any) { host.hidden = true; host.textContent = ''; return; }

      var dur = duration();
      var span = minutes(CFG.closeTime) - minutes(CFG.openTime);
      var msg;

      if (!OPEN_DAYS.filter(function (n) { return n >= 1 && n <= 7; }).length) {
        msg = 'Aucun jour ouvré valide. Le réglage « Jours ouvrés » attend des chiffres, par exemple 2,3,4,5,6 pour mardi à samedi.';
      } else if (dur > span) {
        msg = 'Cette prestation dure ' + dur + ' min, or votre amplitude ' +
              CFG.openTime + '–' + CFG.closeTime + ' n\'offre que ' + span +
              ' min. Élargissez les horaires ou raccourcissez la durée.';
      } else {
        msg = 'Aucune date disponible pour cette prestation. Vérifiez les jours ouvrés, ' +
              'le délai de prévenance (' + (CFG.leadHours || 0) + ' h) et les jours fermés.';
      }
      host.textContent = msg;
      host.hidden = false;
    }

    function renderSlots() {
      var wrap = $('[data-cfb-slots]');
      if (!wrap) return;
      wrap.textContent = '';

      if (!state.date) {
        var p = document.createElement('p');
        p.className = 'cfb__empty';
        p.textContent = L.pickDate;
        wrap.appendChild(p);
        return;
      }

      var list = slotsFor(state.date).filter(function (s) { return !s.tooSoon; });
      if (!list.length) {
        var e = document.createElement('p');
        e.className = 'cfb__empty';
        e.textContent = L.noSlots;
        wrap.appendChild(e);
        return;
      }

      var frag = document.createDocumentFragment();
      list.forEach(function (s) {
        var b = document.createElement('span');
        b.setAttribute('role', 'button');
        b.setAttribute('tabindex', s.taken ? '-1' : '0');
        b.className = 'cfb__slot';
        b.textContent = s.time.replace(':', 'h');
        b.setAttribute('data-cfb-time', s.time);
        b.setAttribute('aria-pressed', state.time === s.time ? 'true' : 'false');
        b.setAttribute('aria-disabled', s.taken ? 'true' : 'false');
        if (s.taken) { b.title = L.unavailable; }
        frag.appendChild(b);
      });
      wrap.appendChild(frag);
    }

    function renderSummary() {
      var variant = findVariant();
      var svc = currentService();

      var setTxt = function (sel, val) { var el = $(sel); if (el) el.textContent = val; };

      setTxt('[data-cfb-recap-service]', state.options[idxService] || '—');
      setTxt('[data-cfb-recap-duration]', duration() + ' ' + L.minutes);
      setTxt('[data-cfb-recap-place]', (svc && svc.location) || '—');
      setTxt('[data-cfb-recap-payment]', idxPayment > -1 ? (state.options[idxPayment] || '—') : '—');

      if (state.date && state.time) {
        var d = parseISO(state.date);
        var human = L.weekdays[isoWeekday(d)] + ' ' + d.getUTCDate() + ' ' +
                    L.months[d.getUTCMonth()] + ' — ' + state.time.replace(':', 'h');
        setTxt('[data-cfb-recap-when]', human);
      } else {
        setTxt('[data-cfb-recap-when]', '—');
      }

      setTxt('[data-cfb-price]', variant ? variant.priceFormatted : '—');

      var idInput = $('[data-cfb-variant-id]');
      if (idInput) idInput.value = variant ? variant.id : '';

      applyFlow();

      // En parcours « demande », aucune variante n'est requise pour valider :
      // la cliente réserve, elle règle au salon.
      var ready = useRequest()
        ? !!(state.date && state.time)
        : !!(variant && variant.available && state.date && state.time);
      $$('[data-cfb-submit]').forEach(function (b) { b.disabled = !ready; });
      setOff($('[data-cfb-bar-submit]'), !ready);

      var bar = $('[data-cfb-bar]');
      if (bar) {
        bar.classList.toggle('is-on', ready);
        var bw = $('[data-cfb-bar-when]');
        var bp = $('[data-cfb-bar-price]');
        if (bw) bw.textContent = $('[data-cfb-recap-when]') ? $('[data-cfb-recap-when]').textContent : '';
        if (bp) bp.textContent = variant ? variant.priceFormatted : '';
      }
    }

    function fieldVal(name) {
      var el = root.querySelector('[data-cfb-field="' + name + '"]');
      return el ? String(el.value || '').trim() : '';
    }

    function bookingLines() {
      var d = parseISO(state.date);
      var human = L.weekdays[isoWeekday(d)] + ' ' + d.getUTCDate() + ' ' +
                  L.months[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
      var svc = currentService();
      var v = findVariant();
      var out = {};
      out['Date du rendez-vous'] = human;
      out['Heure'] = state.time.replace(':', 'h');
      if (svc && svc.location) out['Lieu'] = svc.location;
      if (state.options[idxService]) out['Prestation'] = state.options[idxService];
      if (idxPayment > -1 && state.options[idxPayment]) out['Paiement'] = state.options[idxPayment];
      if (v) out['Montant'] = v.priceFormatted;
      return out;
    }

    function syncProperties() {
      // Régénéré à chaque changement plutôt que laissé se désynchroniser.
      $$('[data-cfb-prop]').forEach(function (el) { el.parentNode.removeChild(el); });
      if (!state.date || !state.time) return;

      var info = bookingLines();
      var phone = fieldVal('Téléphone');
      var note  = fieldVal('Précisions');

      if (formCart) {
        var props = {
          'Date du rendez-vous': info['Date du rendez-vous'],
          'Heure': info['Heure'],
          '_creneau': state.date + ' ' + state.time
        };
        if (info['Lieu']) props['Lieu'] = info['Lieu'];
        if (phone) props['Téléphone'] = phone;
        if (note) props['Précisions'] = note;
        Object.keys(props).forEach(function (key) {
          add(formCart, 'properties[' + key + ']', props[key]);
        });
      }

      if (formRequest) {
        // Le formulaire de contact Shopify n'accepte que quelques champs :
        // tout le détail du rendez-vous part donc dans le corps du message.
        var body = Object.keys(info).map(function (k) { return k + ' : ' + info[k]; });
        if (phone) body.push('Téléphone : ' + phone);
        if (note) body.push('Précisions : ' + note);
        body.push('', 'Demande envoyée depuis la page de réservation. Règlement sur place.');
        add(formRequest, 'contact[Nom]', fieldVal('Nom'));
        add(formRequest, 'contact[email]', fieldVal('email'));
        add(formRequest, 'contact[Téléphone]', phone);
        add(formRequest, 'contact[body]', body.join('\n'));
      }

      function add(f, name, value) {
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = name;
        i.value = value == null ? '' : value;
        i.setAttribute('data-cfb-prop', '');
        f.appendChild(i);
      }
    }

    function cfgProp(k) {
      var map = { date: 'Date du rendez-vous', time: 'Heure', place: 'Lieu' };
      return map[k];
    }

    function renderAll() {
      markChoices();
      renderCalendar();
      renderSlots();
      renderSummary();
      syncProperties();
    }

    /* ---------------- Événements ---------------- */
    root.addEventListener('click', function (e) {
      var choice = e.target.closest('[data-cfb-option]');
      if (choice) {
        var i = +choice.getAttribute('data-cfb-option');
        state.options[i] = choice.getAttribute('data-cfb-value');
        syncChoiceButtons();
        reconcile(i);
        // Changer de prestation change la durée, donc la grille des créneaux
        state.time = null;
        renderAll();
        return;
      }

      var day = e.target.closest('[data-cfb-date]');
      if (day && !isOff(day)) {
        state.date = day.getAttribute('data-cfb-date');
        state.time = null;
        renderCalendar();
        renderSlots();
        renderSummary();
        syncProperties();
        var slots = $('[data-cfb-slots]');
        if (slots && typeof slots.scrollIntoView === 'function') {
          slots.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        return;
      }

      var slot = e.target.closest('[data-cfb-time]');
      if (slot && !isOff(slot)) {
        state.time = slot.getAttribute('data-cfb-time');
        renderSlots();
        renderSummary();
        syncProperties();
        return;
      }

      if (e.target.closest('[data-cfb-prev]') && !isOff(e.target.closest('[data-cfb-prev]'))) {
        state.cursor = new Date(Date.UTC(state.cursor.getUTCFullYear(), state.cursor.getUTCMonth() - 1, 1));
        renderCalendar();
        return;
      }
      if (e.target.closest('[data-cfb-next]') && !isOff(e.target.closest('[data-cfb-next]'))) {
        state.cursor = new Date(Date.UTC(state.cursor.getUTCFullYear(), state.cursor.getUTCMonth() + 1, 1));
        renderCalendar();
        return;
      }
    });

    // La barre mobile n'est pas dans un formulaire : elle relaie vers celui
    // qui correspond au parcours en cours.
    root.addEventListener('click', function (e) {
      var barTrigger = e.target.closest('[data-cfb-bar-submit]');
      if (!barTrigger || isOff(barTrigger)) return;
      e.preventDefault();
      var f = activeForm();
      if (!f) return;
      if (typeof f.requestSubmit === 'function') f.requestSubmit();
      else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });

    // Un <span role="button"> n'a pas l'activation clavier native d'un <button>.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var t = e.target.closest('[role="button"]');
      if (!t || isOff(t)) return;
      e.preventDefault();
      t.click();
    });

    /* ---------------- Envoi ---------------- */
    function onSubmit(e) {
      var err = $('[data-cfb-error]');
      var showError = function (msg) {
        if (!err) return;
        err.textContent = msg;
        err.hidden = false;
      };
      if (err) err.hidden = true;

      if (!state.date || !state.time) {
        e.preventDefault();
        showError(L.chooseSlot);
        return;
      }
      // Parcours « demande » : e-mail natif Shopify, aucun panier, aucune caisse.
      if (useRequest()) {
        if (!fieldVal('email')) {
          e.preventDefault();
          showError(CFG.strings && CFG.strings.emailRequired ? CFG.strings.emailRequired
                    : 'Indiquez votre e-mail pour recevoir la confirmation.');
          return;
        }
        syncProperties();
        return; // le POST natif part vers /contact
      }

      var variant = findVariant();
      if (!variant || !variant.available) {
        e.preventDefault();
        showError(L.unavailable);
        return;
      }

      // Ajout AJAX quand c'est possible, sinon on laisse le POST natif partir.
      if (!window.fetch) return;
      e.preventDefault();

      var submits = $$('[data-cfb-submit], [data-cfb-bar-submit]');
      submits.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(formCart)
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () {
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (d) {
          showError((d && (d.description || d.message)) || L.unavailable);
          submits.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
        });
    }

    if (formCart) formCart.addEventListener('submit', onSubmit);
    if (formRequest) formRequest.addEventListener('submit', onSubmit);

    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-cfb-field]')) syncProperties();
    });

    // Panneau de diagnostic : ajoutez ?cfb=debug à l'URL de la page.
    // Invisible pour vos clientes, il évite de deviner ce qui est réellement
    // installé et pourquoi une prestation ne propose aucune date.
    if (/[?&]cfb=debug/.test(window.location.search)) {
      var box = document.createElement('pre');
      box.style.cssText = 'margin:1.5rem 0 0;padding:1rem;background:#14100D;color:#F0DCA8;' +
        'border-radius:8px;font:12px/1.5 ui-monospace,SFMono-Regular,Menlo,monospace;' +
        'white-space:pre-wrap;overflow-x:auto;';
      var probe = null, probeDay = null;
      for (var k = 0; k < 60; k++) {
        var d = addDays(TODAY, k);
        if (dayIsOpen(d)) { probeDay = toISO(d); probe = slotsFor(probeDay); break; }
      }
      var freeDays = 0;
      for (var j = 0; j < 60; j++) { if (dayHasSlot(addDays(TODAY, j))) freeDays++; }
      var svc = currentService();
      box.textContent = [
        'DIAGNOSTIC — module de réservation',
        'version installée   : ' + (root.getAttribute('data-cfb-version') || 'inconnue'),
        'parcours sur place  : ' + (CFG.onsiteMode || 'non défini') +
          (CFG.onsiteMode === 'request' ? '  (demande par e-mail, sans caisse)' : '  (commande Shopify)'),
        'mode actif          : ' + (useRequest() ? 'DEMANDE E-MAIL' : 'PANIER / CAISSE'),
        'paiement sélectionné: ' + (idxPayment > -1 ? state.options[idxPayment] : 'aucune option paiement'),
        '',
        'prestation          : ' + (state.options[idxService] || '—'),
        'durée retenue       : ' + duration() + ' min' + (svc ? '' : '  (bloc introuvable, valeur par défaut)'),
        'chevauchement pause : ' + (svc && svc.spansBreak ? 'coché' : 'non coché, repli automatique actif'),
        'blocs prestation    : ' + (CFG.services || []).map(function (x) {
            return x.value + '=' + x.duration + 'min' + (x.spansBreak ? '/pause' : '');
          }).join(', '),
        '',
        'amplitude           : ' + CFG.openTime + '–' + CFG.closeTime +
          '  pause ' + (CFG.breakStart || '—') + '–' + (CFG.breakEnd || '—'),
        'jours ouvrés        : ' + CFG.openDays + '   préavis ' + CFG.leadHours + 'h',
        'jours réservables   : ' + freeDays + ' sur les 60 prochains',
        'premier jour ouvert : ' + (probeDay || 'aucun'),
        'créneaux ce jour-là : ' + (probe && probe.length
            ? probe.map(function (x) { return x.time + (x.taken ? '(pris)' : '') + (x.tooSoon ? '(trop tôt)' : ''); }).join(' ')
            : 'AUCUN'),
        '',
        'variantes produit   : ' + (CFG.variants || []).length,
        'variante résolue    : ' + (findVariant() ? findVariant().id + ' — ' + findVariant().priceFormatted : 'aucune')
      ].join('\n');
      var host = root.querySelector('.cfb__wrap') || root;
      host.insertBefore(box, host.firstChild);
    }

    renderAll();
  }

  function boot() {
    document.querySelectorAll('[data-cfb-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Rechargement dans l'éditeur de thème
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cfb-root]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
